import { render, staticRenderFns } from "./DiffList.vue?vue&type=template&id=2d9fc240&"
import script from "./DiffList.vue?vue&type=script&lang=ts&"
export * from "./DiffList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports